var CODE = /^[A-Z0-9]+(?:_[A-Z0-9]+)*$/;
/** `SOMETHING_NEW` as "Something new"; text that is not a code as it is. */
export function humaniseCode(code) {
    if (!CODE.test(code))
        return code;
    var words = code.toLowerCase().replace(/_/g, " ");
    return words.charAt(0).toUpperCase() + words.slice(1);
}
/** A notice the server sent, in the viewer's language; an unknown one as words. */
export function noticeText(t, code) {
    return t("monitoring.notices.".concat(code), { defaultValue: humaniseCode(code) });
}
